export default "__VITE_ASSET__ace4fa31__"